import { logToDevConsole } from 'src/utils/reporting/report-errors'

import { loadColors } from 'src/colors'

const hexColorRegExp = /^#([\dA-F]{3}|[\dA-F]{6})$/i

const normalizeCssVariableName = (colorKey: string): string => (
  colorKey.startsWith('--') ? colorKey : `--${colorKey}`
)

const toCssVariables = (runtimeColors: Record<string, string>): Record<string, string> => {
  return Object.entries(runtimeColors).reduce<Record<string, string>>((acc, [key, value]) => {
    if (!hexColorRegExp.test(value)) {
      return acc
    }

    acc[normalizeCssVariableName(key)] = value

    return acc
  }, {})
}

export const applyRuntimeColors = (runtimeColors: Record<string, string>) => {
  const cssVariables = toCssVariables(runtimeColors)
  const rootStyle = document.documentElement.style

  Object.entries(cssVariables).forEach(([cssVariableName, colorValue]) => {
    rootStyle.setProperty(cssVariableName, colorValue)
  })
}

export const loadAndApplyRuntimeColors = async () => {
  try {
    const runtimeColors = await loadColors()

    applyRuntimeColors(runtimeColors)
  } catch (error) {
    logToDevConsole(error)
  }
}
